import React from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";

import { MaterialIcons } from "@expo/vector-icons";
import { FormattedMessage } from "react-intl";

const ModalPaperWalletDeposit = ({
  handleCloseModal,
  handleCloseWithTransaction,
}) => {
  return (
    <>
      <View style={styles.container}>
        <Text style={styles.text}>
          <FormattedMessage id="modalpaperwalletdeposit.oDeposito" />{" "}
          <Text style={styles.success}>
            <FormattedMessage id="modalpaperwalletdeposit.sucesso" />
          </Text>
        </Text>

        <TouchableOpacity
          onPress={() => {
            handleCloseWithTransaction();
          }}
        >
          <Text
            style={{
              textTransform: "uppercase",
              fontFamily: "Poppins, sans-serif",
              padding: 10,
              width: 320,
              height: 38,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 4,
              backgroundColor: "#077A97",
              marginVertical: 12,
              alignSelf: "center",
              color: "#fff",
              textAlign: "center",
            }}
          >
            <FormattedMessage id="modalPaperWallet.btnFechar" />
          </Text>
        </TouchableOpacity>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 350,
    alignSelf: "center",
    alignItems: "center",
    padding: 12,
    marginTop: 80,
    borderRadius: 8,
    borderColor: "#077A97",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  text: {
    fontSize: 16,
    marginTop: 30,
    textAlign: "center",
    textTransform: "uppercase",
    color: "#077A97",
    fontWeight: "bold",
  },
  success: {
    fontWeight: "bold",
    color: "#077A97",
  },
});

export default ModalPaperWalletDeposit;
